
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      title: "Member Contributions",
      description: "Build your financial future with flexible contribution plans. Earn competitive returns while supporting your community.",
      icon: "ri-piggy-bank-line",
      features: ["Flexible payment plans", "Competitive interest rates", "Secure investments", "Regular dividends"],
      link: "/contribute",
      image: "https://public.readdy.ai/ai/img_res/af2041abbc2c0cf47673591bc2951048.jpg"
    },
    {
      title: "Personal Loans",
      description: "Access affordable loans for your personal needs. Quick approval process with member-friendly interest rates.",
      icon: "ri-hand-coin-line",
      features: ["Low interest rates", "Quick approval", "Flexible repayment", "No hidden fees"],
      link: "/loans",
      image: "https://readdy.ai/api/search-image?query=Professional%20loan%20officer%20helping%20diverse%20clients%20with%20paperwork%2C%20modern%20office%20setting%2C%20handshake%20agreement%2C%20financial%20consultation%2C%20trust%20and%20reliability%2C%20cooperative%20banking%20atmosphere%2C%20clean%20professional%20environment&width=400&height=300&seq=loan-service&orientation=landscape"
    },
    {
      title: "Business Loans",
      description: "Fuel your entrepreneurial dreams with our business loan programs. Support for small and medium enterprises.",
      icon: "ri-building-line",
      features: ["Business expansion", "Equipment financing", "Working capital", "Competitive rates"],
      link: "/loans",
      image: "https://readdy.ai/api/search-image?query=Small%20business%20owners%20receiving%20financial%20support%2C%20modern%20office%20meeting%2C%20business%20growth%20concept%2C%20professional%20consultation%2C%20diverse%20entrepreneurs%2C%20cooperative%20business%20lending%2C%20success%20and%20partnership%20theme&width=400&height=300&seq=business-loan&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our Financial Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover comprehensive financial solutions designed to help you achieve your goals 
            while strengthening our cooperative community.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${service.image}')` }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {service.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-600">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link 
                  to={service.link}
                  className="block w-full bg-teal-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Learn More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}